document.addEventListener("DOMContentLoaded", function () {
  const faqs = document.querySelectorAll(".content-questions-answers");
  console.log("FAQ elements found:", faqs.length); // Verifica que encuentra los elementos
  faqs.forEach((faq) => {
    const question = faq.querySelector(".content-questions");
    const answer = faq.querySelector(".content-answers");

    faq.classList.remove("active");
    answer.style.maxHeight = null;
    answer.style.marginBottom = null;

    question.addEventListener("click", function () {
      faqs.forEach((otherFaq) => {
        if (otherFaq !== faq) {
          otherFaq.classList.remove("active");
          const otherAnswer = otherFaq.querySelector(".content-answers");
          otherAnswer.style.maxHeight = null;
          otherAnswer.style.marginBottom = null;
        }
      });

      if (faq.classList.contains("active")) {
        faq.classList.remove("active");
        answer.style.maxHeight = null;
        answer.style.marginBottom = null;
      } else {
        faq.classList.add("active");
        answer.style.maxHeight = answer.scrollHeight + "px";
        answer.style.marginBottom = "15px";
      }
    });
  });
});
